import { KeyValue } from '@/main/models/common';
import { CultureFilterRequest } from '@/main/models/request/cultureRequest';

export enum CultureTypes {
  GET_CULTURE = '@culture/GET_CULTURE',
  SAVE_CULTURE = '@culture/SAVE_CULTURE',
  RESET_REDUCER_CULTURE = '@culture/RESET_REDUCER_CULTURE'
}

export interface CultureState {
  readonly culture: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetCulture {
  type: typeof CultureTypes.GET_CULTURE;
  payload: {
    request: CultureFilterRequest;
  };
}

export interface SaveCulture {
  type: typeof CultureTypes.SAVE_CULTURE;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerCulture {
  type: typeof CultureTypes.RESET_REDUCER_CULTURE;
}

export type CultureActionTypes =
  | GetCulture
  | SaveCulture
  | ResetReducerCulture;
